import { render, staticRenderFns } from "./ConfigurationInformationSide.vue?vue&type=template&id=4803ffa4&scoped=true"
import script from "./ConfigurationInformationSide.vue?vue&type=script&lang=ts"
export * from "./ConfigurationInformationSide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803ffa4",
  null
  
)

export default component.exports